import { Box, Text } from "grommet";
import React, { useMemo } from "react";
import { AxisOptions, Chart } from "react-charts";
import StandardColors from "../../../../../../../util/StandardColors";
import "./BarChart.css";

type DiversionCount = {
  x: string;
  y: number;
  color: string;
};

type Series = {
  label: string;
  data: DiversionCount[];
};

function BarChart({ data }: { data: { x: string; y: number, color: string }[] }) {
  const primaryAxis = React.useMemo(
    (): AxisOptions<DiversionCount> => ({
      getValue: (datum) => datum.x,
    }),
    []
  );

  const secondaryAxes = React.useMemo(
    (): AxisOptions<DiversionCount>[] => [
      {
        getValue: (datum) => datum.y,
        elementType: "bar",
        min: 0,
      },
    ],
    []
  );

  const lineData: Series[] = useMemo(
    () => [
      {
        label: "Diversion Recommendation Stats",
        data: data as DiversionCount[],
      },
    ],
    [data]
  );

  return (
    <>
      {data.reduce((prev, current, index, _) => {
        if (current.y !== 0 || prev) return true;
        return false;
      }, false) ? (
        <Chart
          options={{
            data: lineData,
            primaryAxis,
            secondaryAxes,
            defaultColors: [
              "red",
              "green",
            ],
          }}
        />
      ) : (
        <Box fill align="center" justify="center">
          <Text color={"black_20"}>No decision taken for any flight.</Text>
        </Box>
      )}
    </>
  );
}

export default BarChart;
